import { Answer, Question, DimensionScore, AssessmentDimension, MaturityLevel } from "../types/assessment";

const CATEGORY_WEIGHTS = {
  strategy: 0.3,    // 30%
  data: 0.25,       // 25%
  talent: 0.15,     // 15%
  deployment: 0.2,  // 20%
  innovation: 0.1   // 10%
};

export const calculateDimensionScores = (answers: Answer[], questions: Question[]): DimensionScore[] => {
  console.log("Calculating dimension scores with answers:", answers);
  
  const dimensions: AssessmentDimension[] = ["strategy", "data", "talent", "deployment", "innovation"];
  
  return dimensions.map(dimension => {
    const dimensionQuestions = questions.filter(q => q.dimension === dimension);
    const dimensionAnswers = answers.filter(a => 
      dimensionQuestions.some(q => q.id === a.questionId)
    );
    
    const totalScore = dimensionAnswers.reduce((sum, answer) => sum + answer.value, 0);
    const averageScore = dimensionQuestions.length > 0 ? totalScore / dimensionQuestions.length : 0;
    
    console.log(`${dimension} score:`, averageScore);
    
    return {
      dimension,
      score: Number(averageScore.toFixed(2))
    };
  });
};

export const calculateOverallScore = (dimensionScores: DimensionScore[]): number => {
  const weightedSum = dimensionScores.reduce((sum, score) => {
    const weight = CATEGORY_WEIGHTS[score.dimension] || 0;
    return sum + (score.score * weight);
  }, 0);

  console.log("Overall weighted score:", weightedSum);
  return Number(weightedSum.toFixed(2));
};

export const getMaturityLevel = (score: number): MaturityLevel => {
  if (score <= 1.5) return "Ad-Hoc Experimentation";
  if (score <= 2.5) return "Opportunistic Adoption";
  if (score <= 3.5) return "Strategic Integration";
  if (score <= 4.5) return "Embedded Intelligence";
  return "AI-Driven Enterprise";
};

export const getMaturityDescription = (level: MaturityLevel): string => {
  const descriptions: Record<MaturityLevel, string> = {
    "Ad-Hoc Experimentation": "No AI strategy, sporadic initiatives, isolated pilots.",
    "Opportunistic Adoption": "AI exists in pockets, but lacks enterprise-wide integration.",
    "Strategic Integration": "AI is aligned with business objectives, scaling across functions.",
    "Embedded Intelligence": "AI is embedded in workflows, driving efficiency and value.",
    "AI-Driven Enterprise": "AI is at the core of strategy, continuously innovating."
  };
  return descriptions[level];
};

export const generateAssessmentReport = (
  dimensionScores: DimensionScore[],
  overallScore: number
): {
  overallScore: number;
  maturityLevel: MaturityLevel;
  description: string;
  dimensionScores: DimensionScore[];
} => {
  const maturityLevel = getMaturityLevel(overallScore);
  
  return {
    overallScore,
    maturityLevel,
    description: getMaturityDescription(maturityLevel),
    dimensionScores
  };
};

export const convertDimensionScoresToRecord = (dimensionScores: DimensionScore[]): Record<string, number> => {
  return dimensionScores.reduce((acc, curr) => {
    acc[curr.dimension] = curr.score;
    return acc;
  }, {} as Record<string, number>);
};
